import { createAtom } from '../../../1stlog-ui/src/utils/recoil'
import { TReturnAppReceiver } from './TReturnApp'

export const receiverState = createAtom<TReturnAppReceiver>({
  prefix: 'containers/ReturnAppUpdate',
  key: 'receiver',
})
